// extracted by mini-css-extract-plugin
export default {"customerData":"CustomerInfo_customerData__m8wz4"};